export default {
  data: () => ({
    form: {}
  }),

  computed: {
    getAdditionalInformation() {
      return {
        is_service_employee: this.form.additional_information
          .is_service_employee,
        is_concierge: this.form.additional_information.is_concierge,
        service_ids: this.form.additional_information.services.map(i => i.id),
        building_complex_ids: this.form.additional_information.building_complexes.map(
          i => i.id
        ),
        region_ids: this.form.additional_information.regions.map(i => i.id),
        skill_ids: this.form.additional_information.skills.map(i => i.id)
      };
    }
  }
};
